import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import {useEffect} from "react"
import styled from "styled-components"

const DetailsScreen = () => {
	useEffect(() => {
		document.title = 'АТС24 — Информация о тарифах'
	}, [])

	const monitoring = [[['1', '7 500'], '2.50'], [['7 501', '15 000'], '2.20'], [['15 001', '30 000'], '1.90'], [['30 001', '60 000'], '1.60'], [['60 001', '120 000'], '1.30'], [['120 001', '200 000'], '1.00'], [['200 001', '300 000'], '0.80'], [['300 001', '500 000'], '0.60'], [['500 001'], '0.50']]
	const routing = [[['1', '7 500'], '1.25'], [['7 501', '15 000'], '1.10'], [['15 001', '30 000'], '0.95'], [['30 001', '60 000'], '0.80'], [['60 001', '120 000'], '0.65'], [['120 001', '200 000'], '0.50'], [['200 001', '300 000'], '0.40'], [['300 001', '500 000'], '0.30'], [['500 001'], '0.25']]
	const sensors = [[[1, 5], '600.00'], [[6, 15], '450.00'], [[16, 30], '360.00'], [[31], '290.00']]

	const PriceTable = ({title, data}) => (
		<div>
			<TableTitle>{title}</TableTitle>
			<table className="price-table">
				<tr>
					<th>Диапазон</th>
					<th>Стоимость за единицу, ₽</th>
				</tr>
				{data.map(item => (
					<tr>
						<td>{item[0][0]}{item[0][1] ? ' — ' + item[0][1] : ' +'}</td>
						<td>{item[1]}</td>
					</tr>
				))}
			</table>
		</div>

	)

	return (
		<ContentBlock top={2} gap={1}>
			<ContentCard title="Информация о тарифах">
				<p>
					Тарификация основана на диапазонах: стоимость единицы зависит от того, в какой весовой группе
					(диапазоне) она находится.
				</p>
			</ContentCard>

			<Price>
				<TableWrapper>
					<PriceTable data={monitoring} title="Мониторинг доставки"/>
				</TableWrapper>
				<DescriptionWrapper>

				</DescriptionWrapper>
			</Price>
			<Price>
				<TableWrapper>
					<PriceTable data={routing} title="Маршрутизация"/>
				</TableWrapper>
				<DescriptionWrapper>

				</DescriptionWrapper>
			</Price>
			<Price>
				<TableWrapper>
					<PriceTable data={sensors} title="Встроенные датчики"/>
				</TableWrapper>
				<DescriptionWrapper>

				</DescriptionWrapper>
			</Price>
		</ContentBlock>
	)
}

export default DetailsScreen

const Price = styled.div`
    display: flex;
    flex: 1;
    margin-top: 40px;
`
const TableWrapper = styled.div`
    flex: 0.5;
`
const DescriptionWrapper = styled.div`
    flex: 0.5;
`
const TableTitle = styled.div`
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
`